import { render, staticRenderFns } from "./LoaderCardComponent.vue?vue&type=template&id=2061d7ce"
import script from "./LoaderCardComponent.vue?vue&type=script&lang=ts"
export * from "./LoaderCardComponent.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports